import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useHistory } from 'react-router';
import styled, { css } from 'styled-components';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import LINKS from '../../../../../configs/links';
import { useCopyToClipboard } from '../../../../../utils/copy';
import { showChat } from '../../../../../utils/liveChat';
import { rejection_cause_labels } from '../../../../../utils/rejection-causes';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Icon from '../../../../common/base/Icon';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import CopyableField from '../../../../common/CopyableField';
import DisplayDate from '../../../../common/DisplayDate';
import StyledEllipsisOverflow from '../../../../common/helpers/EllipsisOverflow';
import { Div } from '../../../../common/helpers/StyledUtils';
import Modal from '../../../../common/Modal';
import { Status } from '../../../../common/Status';
import Table from '../../../../common/Table/Table';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { UserContext } from '../../../../contexts/UserContext';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import Container from '../../../../common/base/Container';
const StyledNumber = styled.div(({
  theme
}) => css`
    border-radius: 50%;
    height: ${theme.pxToRem(24)};
    width: ${theme.pxToRem(24)};
    line-height: ${theme.pxToRem(theme.font_sizes.s.line_height)};
    font-weight: ${theme.font_weights.medium};
    font-size: ${theme.pxToRem(theme.font_sizes.s.font_size)};
    margin-right: ${theme.spacing(4)};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.surface.container.neutral};
  `);
const PostCreateModal = () => {
  const $ = _c(35);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    user
  } = useContext(UserContext);
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  const history = useHistory();
  const copyToClipboard = useCopyToClipboard();
  let t0;
  if ($[0] !== query.created) {
    t0 = query.created && APIMethodKeys.webhooks.get(query.created);
    $[0] = query.created;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== query.created) {
    t1 = () => HookdeckAPI.webhooks.get(query.created);
    $[2] = HookdeckAPI.webhooks;
    $[3] = query.created;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: connection
  } = useSWR(t0, t1);
  let t2;
  if ($[5] !== connection) {
    t2 = connection && {
      source_id: connection?.source.id,
      limit: 5,
      status: "rejected",
      ingested_at: {
        gte: connection?.created_at
      }
    };
    $[5] = connection;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const request_filters = t2;
  let t3;
  if ($[7] !== request_filters) {
    t3 = request_filters && APIMethodKeys.requests.list(request_filters);
    $[7] = request_filters;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== HookdeckAPI.requests || $[10] !== request_filters) {
    t4 = () => HookdeckAPI.requests.list(request_filters);
    $[9] = HookdeckAPI.requests;
    $[10] = request_filters;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      refreshInterval: 2000,
      revalidateOnFocus: true
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    data: requests
  } = useSWR(t3, t4, t5);
  let t6;
  if ($[13] !== connection) {
    t6 = connection && APIMethodKeys.events.list({
      webhook_id: [connection?.id],
      limit: 5,
      cli_id: {
        all: true
      }
    });
    $[13] = connection;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== HookdeckAPI.events || $[16] !== connection?.id) {
    t7 = () => HookdeckAPI.events.list({
      webhook_id: [connection?.id],
      limit: 5,
      cli_id: {
        all: true
      }
    });
    $[15] = HookdeckAPI.events;
    $[16] = connection?.id;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      refreshInterval: 2000,
      revalidateOnFocus: true
    };
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const {
    data: events
  } = useSWR(t6, t7, t8);
  let t9;
  if ($[19] !== connection || $[20] !== user) {
    t9 = connection && connection.destination.type === "CLI" && user && APIMethodKeys.cli_clients.list({
      active: true
    });
    $[19] = connection;
    $[20] = user;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== HookdeckAPI.cli_clients) {
    t10 = () => HookdeckAPI.cli_clients.getSessions({
      active: true
    });
    $[22] = HookdeckAPI.cli_clients;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const {
    data: active_cli_sessions
  } = useSWR(t9, t10);
  let t11;
  if ($[24] !== events || $[25] !== requests) {
    t11 = [...(events ? events.models.map(_temp) : []), ...(requests ? requests.models.map(_temp2) : [])];
    $[24] = events;
    $[25] = requests;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const rows = t11;
  if (!connection) {
    return null;
  }
  let t12;
  if ($[27] !== active_cli_sessions || $[28] !== connection || $[29] !== copyToClipboard || $[30] !== history || $[31] !== query.troubleshoot || $[32] !== rows || $[33] !== updateSearchQuery) {
    t12 = <>{!query.troubleshoot ? <Modal onClose={() => updateSearchQuery({
        created: undefined
      })}><Container small={true} flex={{
          justify: "center",
          align: "center",
          direction: "column"
        }} p={0} m={{
          t: 4,
          b: 8
        }}><Text bold={true} size="l" as="h3" flex={{
            align: "center"
          }} center={true} m={{
            b: 2,
            t: 0
          }}><Icon icon="success_circle" success={true} left={true} large={true} />Connection created</Text><Text as="p" muted={true} center={true} m={{
            b: 5
          }}>Use this URL to receive your requests from "{connection.source.name}". Valid requests to this URL will be sent to your destination "{connection.destination.name}". Hookdeck will reply immediately with an HTTP 200.</Text><CopyableField mono={true} value={connection?.source.url} /></Container>{connection && connection?.destination.type === "CLI" && active_cli_sessions && active_cli_sessions.length === 0 && <><StyledCard overflow_hidden={true} m={{
            t: 6
          }}><StyledCardSection p={{
              x: 4,
              y: 1
            }} muted={true}><Text size="s" muted={true} semi={true}>Connect the CLI</Text></StyledCardSection><StyledCardSection p={4}><Div flex={{
                align: "center"
              }}><StyledNumber>1</StyledNumber><Text>To receive events on your local server,{" "}<Link href={LINKS.product_docs.cli_install}>install our CLI {"->"}</Link></Text></Div><Div flex={{
                align: "center"
              }} m={{
                y: 4
              }}><StyledNumber>2</StyledNumber><Text m={{
                  r: 1
                }}>Run</Text><Div as="code" m={{
                  r: 1
                }}>hookdeck login</Div><Button ghost={true} onClick={() => copyToClipboard("hookdeck login")} icon="copy" /></Div><Div flex={{
                align: "center"
              }}><StyledNumber>3</StyledNumber><Text m={{
                  r: 1
                }}>Run</Text><Div as="code" m={{
                  r: 1
                }}>hookdeck listen [PORT] {connection.source.name}</Div><Button ghost={true} onClick={() => copyToClipboard(`hookdeck listen [PORT] ${connection.source.name}`)} icon="copy" /></Div></StyledCardSection></StyledCard></>}{connection && (connection.destination.type !== "CLI" || active_cli_sessions && active_cli_sessions.length > 0) && <StyledCard overflow_hidden={true} m={{
          t: 4
        }} style={{
          position: "relative"
        }}>{rows.length > 0 ? <Table widths={[0.5, 0.5, {
            min: 20,
            max: 20
          }]} headers={["Status", "Date", ""]} rows={rows} onRowSelected={id => {
            if (id?.startsWith("evt_")) {
              history.push(`/events/${id}`);
            } else {
              history.push(`/requests/${id}`);
            }
          }} /> : <StyledCardSection muted={true} flex={{
            align: "center",
            justify: "center",
            direction: "column"
          }} p={{
            x: 11,
            y: 30
          }}><Icon icon="loading" m={{
              b: 2
            }} /><Text semi={true}>Waiting on your first request</Text><Div w={100} flex={{
              justify: "center"
            }} style={{
              position: "absolute",
              bottom: "8px"
            }}><Button ghost={true} icon="help" onClick={() => updateSearchQuery({
                troubleshoot: true
              })} m={{
                t: 6,
                x: "auto"
              }}>I don't see my requests</Button></Div></StyledCardSection>}</StyledCard>}<Div flex={{
          justify: "space-between"
        }} m={{
          t: 5
        }}><Button outline={true} onClick={() => updateSearchQuery({
            created: undefined
          })}>Close</Button><Button primary={true} to={`/events?webhook_id=${connection.id}`} icon="events">View all events</Button></Div></Modal> : <Modal submit_label="Help" onSubmit={showChat} title="Request troubleshooting" onClose={() => updateSearchQuery({}, {
        remove_keys: ["troubleshoot"]
      })}><Text m={{
          b: 4
        }}>Your requests may not be showing for a variety of reasons:</Text><StyledCard p={4}><Text bold={true} m={{
            b: 2
          }}>Request method is HTTP <code>GET</code></Text><Text muted={true}>Hookdeck does not accept HTTP GET requests unless explicitly enabled on your Source</Text></StyledCard><StyledCard p={4} m={{
          t: 4
        }}><Text bold={true} m={{
            b: 2
          }}>The Content-Type is not supported or unparsable</Text><Text muted={true}>Hookdeck accepts requests with one of the following "Content-Type" HTTP header values:</Text><pre>text/plain <br />text/xml <br />application/json <br />application/x-www-form-urlencoded <br />application/xml <br />application/*+json <br />multipart/form-data<br /></pre><Text muted={true}>In some instances, the Content-Type is supported but the data is unparsable. Hookdeck will reject the request.</Text></StyledCard><StyledCard p={4} m={{
          t: 4
        }}><Text bold={true} m={{
            b: 2
          }}>The sender implements a challenge to verify the webhook URL</Text><Text muted={true}>Some webhook providers implement custom handshakes to verify the URL (also know as "Challenges"). Hookdeck will implement support for these handshakes on an ad-hoc basis when they are requested.{" "}<a href={LINKS.product_docs.inbuilt_source_support} target="_blank" rel="noreferrer">View the current list of supported platforms</a>.<br /><Button outline={true} m={{
              t: 3
            }} onClick={showChat}>Request a new one</Button></Text></StyledCard><StyledCard p={4} m={{
          t: 4
        }}><Text bold={true} m={{
            b: 2
          }}>The sender requires whitelisting our IP</Text><Text muted={true}>In some rare cases the providers might require you to whitelist Hookdeck IP's to send requests to our servers. You can whitelist Cloudflare IPs which are found{" "}<a href="http://cloudflare.com/ips/" target="_blank" rel="noreferrer">here</a>.</Text></StyledCard></Modal>}</>;
    $[27] = active_cli_sessions;
    $[28] = connection;
    $[29] = copyToClipboard;
    $[30] = history;
    $[31] = query.troubleshoot;
    $[32] = rows;
    $[33] = updateSearchQuery;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
export default PostCreateModal;
function _temp(event) {
  return {
    id: event.id,
    fields: [<span key={event.id}><Status {...event} show_response={true} /></span>, <DisplayDate key={event.id} date={event.created_at} />, <Div w={100} flex={{
      justify: "center"
    }} key={event.id}><Icon muted={true} icon="link" pointer={true} /></Div>]
  };
}
function _temp2(request) {
  return {
    id: request.id,
    fields: [<span key={request.id} style={{
      maxWidth: "100%"
    }}><Badge danger={true}><Icon icon="error" left={true} /><StyledEllipsisOverflow>{rejection_cause_labels[request.rejection_cause]}</StyledEllipsisOverflow></Badge></span>, <DisplayDate key={request.id} date={request.ingested_at} />, <Div w={100} flex={{
      justify: "center"
    }} key={request.id}><Icon muted={true} icon="link" pointer={true} /></Div>]
  };
}